module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-05-61c21d5042f16d4b66c87bb6b9ac61fb.svg";